import { TOGGLE_EXPANDED } from './constants'
import type { Expanded, OnExpandOptions } from './types'

export function getExtendType({ owner, saleType }: Pick<OnExpandOptions, 'owner' | 'saleType'>) {
  if (owner) return 'owners'
  if (saleType) return 'saleTypes'

  return 'channels'
}

export function onExpand({ channelsType, countryId, expanded, label, owner, saleType, type }: OnExpandOptions) {
  const toCollapse: Partial<Expanded> = {}
  const countryType = getExtendType({ owner, saleType })
  const expandType: keyof Expanded = type === 'countries' && channelsType !== 'countries' ? `countries-${countryType}` : type
  const value = type === 'countries' ? countryId : label

  if (channelsType === type) {
    toCollapse['countries-channels'] = null
    toCollapse['countries-saleTypes'] = null

    if (channelsType === 'countries') {
      toCollapse.channels = null
    }
  }

  if (channelsType === 'channels') {
    toCollapse.saleTypes = null
  }

  if (channelsType === 'saleTypes') {
    toCollapse.channels = null
  }

  if (channelsType === 'countries') {
    toCollapse.saleTypes = null
  }

  return {
    type: TOGGLE_EXPANDED,
    payload: {
      ...toCollapse,
      [expandType]: expanded ? value : null,
    },
  }
}
